// import React, { useEffect, useRef } from "react";
// import {
//   Box,
//   Typography,
//   useMediaQuery,
//   useTheme,
//   Stack,
// } from "@mui/material";

// import MasterCardImg from "./master-card.png";
// import PaypalImg from "./paypal-logo.png";
// import VisaImg from "./visaicon.png";
// import RazorpayImg from "./razorpay-icon.png";
// import AmexImg from "./amex-logo.png";
// import GooglePayImg from "./google-pay.png";
// import PhonePayImg from "./Phonepay.png";

// const PaymentMethod = () => {
//   const theme = useTheme();
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

//   //  each card's border color with transparency for glassy effect
//   const paymentLogos = [
//     {
//       img: MasterCardImg,
//       alt: "MasterCard",
//       borderColor: "rgba(251, 191, 36, 0.4)", // yellow-ish transparent
//     },
//     {
//       img: AmexImg,
//       alt: "American Express",
//       borderColor: "rgba(30, 58, 138, 0.4)", // blue transparent
//     },
//     {
//       img: VisaImg,
//       alt: "Visa",
//       borderColor: "rgba(59, 130, 246, 0.4)", // blue transparent
//     },
//     {
//       img: PaypalImg,
//       alt: "PayPal",
//       borderColor: "rgba(37, 99, 235, 0.4)", // blue transparent
//     },
//     {
//       img: RazorpayImg,
//       alt: "Razorpay",
//       borderColor: "rgba(15, 23, 42, 0.4)", // dark transparent
//     },
//     {
//       img: GooglePayImg,
//       alt: "Google Pay",
//       borderColor: "rgba(229, 57, 53, 0.4)", // red transparent
//     },
//     {
//       img: PhonePayImg,
//       alt: "Phone Pay",
//       borderColor: "rgba(139, 92, 246, 0.4)", // purple transparent
//     },
//   ];

//   const scrollRef = useRef(null);

//   useEffect(() => {
//     const scrollContainer = scrollRef.current;
//     let scrollAmount = 0;

//     const autoScroll = () => {
//       if (scrollContainer) {
//         scrollAmount += 1;
//         if (
//           scrollAmount >=
//           scrollContainer.scrollWidth - scrollContainer.clientWidth
//         ) {
//           scrollAmount = 0;
//         }
//         scrollContainer.scrollTo({
//           left: scrollAmount,
//           behavior: "smooth",
//         });
//       }
//     };

//     const interval = setInterval(autoScroll, 30);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <Stack
//       sx={{
//         py: 6,
//         backgroundImage: `url('bg1.svg')`,
//         backgroundSize: "cover",
//         backgroundRepeat: "no-repeat",
//         backgroundPosition: "center",
//       }}
//     >
//       <Box
//         sx={{
//           textAlign: "center",
//           px: 2,
//           width: { xl: "80%", lg: "90%", md: "95%", sm: "100%", xs: "100%" },
//           mx: "auto",
//         }}
//       >
//         <Typography
//           variant="h4"
//           fontWeight="bold"
//           color="white"
//           gutterBottom
//           sx={{
//             fontSize: { xs: "20px", sm: "24px", md: "28px", lg: "40px" },
//           }}
//         >
//           Payment Method
//         </Typography>

//         <Typography
//           variant="body1"
//           sx={{
//             color: "white",
//             mb: 4,
//             fontSize: { xs: "16px", sm: "20px", md: "20px", lg: "24px" },
//             textAlign: "justify",
//           }}
//         >
//           Our payment partners are Paypal & RazorPay so you can securely and
//           confidently make payments from anywhere in the world.
//         </Typography>

//         {/* Scrollable Cards */}
//         <Box
//           ref={scrollRef}
//           sx={{
//             display: "flex",
//             overflowX: "auto",
//             gap: 3,
//             px: 2,
//             scrollbarWidth: "none",
//             msOverflowStyle: "none",
//             "&::-webkit-scrollbar": { display: "none" },
//             maskImage:
//               "linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)",
//           }}
//         >
//           {paymentLogos.map((logo, index) => (
//             <Box
//               key={index}
//               sx={{
//                 minWidth: "180px",
//                 height: "120px",
//                 borderRadius: "16px",
//                 border: `2px solid ${logo.borderColor}`,
//                 backdropFilter: "blur(8px)",
//                 WebkitBackdropFilter: "blur(8px)",
//                 backgroundColor: "rgba(255, 255, 255, 0.2)", // white glassy background
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 boxShadow: `0 4px 15px ${logo.borderColor}`,
//               }}
//             >
//               <img
//                 src={logo.img}
//                 alt={logo.alt}
//                 style={{ maxWidth: "80%", maxHeight: "80%" }}
//               />
//             </Box>
//           ))}
//         </Box>
//       </Box>
//     </Stack>
//   );
// };

// export default PaymentMethod;




import React, { useRef, useEffect } from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { keyframes } from '@emotion/react'; 
import MasterCardImg from './master-card.png';
import PaypalImg from './paypal-logo.png';
import VisaImg from './visaicon.png';
import RazorpayImg from './razorpay-icon.png';
import AmexImg from './amex-logo.png';
import GooglePayImg from './google-pay.png';
import PhonePayImg from './Phonepay.png';

const scrollAnimation = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%); /* Scroll exactly half the content (the first set of logos) */
  }
`;

const PaymentMethod = () => {
  const paymentLogos = [
    { img: MasterCardImg, alt: 'MasterCard' },
    { img: AmexImg, alt: 'American Express'},
    { img: VisaImg, alt: 'Visa'},
    { img: PaypalImg, alt: 'PayPal' },
    { img: RazorpayImg, alt: 'Razorpay'},
    { img: GooglePayImg, alt: 'Google Pay'},
    { img: PhonePayImg, alt: 'PhonePe'},
  ];

  const duplicatedLogos = [...paymentLogos, ...paymentLogos];
  const containerRef = useRef(null);

  return (
    <Stack
      sx={{
        py: 6,
        backgroundImage: `url('bg1.svg')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      <Box
        sx={{
          textAlign: 'left',
          px: 2,
          width: { xl: '80%', lg: '90%', md: '95%', sm: '100%', xs: '100%' },
          mx: 'auto',
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          color="white"
          gutterBottom
          sx={{ fontSize: { xs: '20px', sm: '24px', md: '28px', lg: '38px' } }}
        >
          Payment Method
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: 'white',
            mb: 4,
            fontSize: { xs: '16px', sm: '20px', md: '20px', lg: '24px' },
            textAlign: 'justify',
          }}
        >
          Our payment partners are PayPal and Razorpay, so you can securely and confidently make payments from anywhere in the world.
        </Typography>

        <Box
          sx={{
            overflow: 'hidden', 
            whiteSpace: 'nowrap', 
            maskImage: 'linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)',
          }}
        >
          {/* Inner container animated */}
          <Box
            ref={containerRef}
            sx={{
              display: 'inline-flex', 
              gap: 3,
              px: 2,
              animation: `${scrollAnimation} 30s linear infinite`, 
            }}
          >
            {duplicatedLogos.map((logo, index) => (
              <Box
                key={index}
                sx={{
                  flexShrink: 0, 
                  width: '220px',
                  height: '130px',
                  borderRadius: '16px',
                  // border: logo.isGradient ? '2px solid transparent' : `2px solid ${logo.borderColor}`,
                  borderImage: logo.isGradient
                    ? 'linear-gradient(to right, #00008B, #ADD8E6) 1' 
                    : 'none',
                  backdropFilter: 'blur(8px)',
                  WebkitBackdropFilter: 'blur(8px)',
                  border: "1px solid rgba(250, 248, 248, 0.5)",
                  backgroundColor: 'rgba(241, 241, 241, 0.4)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  boxShadow: `0 4px 15px ${logo.borderColor}`,
                }}
              >
                <img
                  src={logo.img}
                  alt={logo.alt}
                  style={{ maxWidth: '80%', maxHeight: '80%', objectFit: 'contain' }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Stack>
  );
};

export default PaymentMethod;


